import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                menu: {
                    route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), '')}.home`,
                    text: 'home.title',
                    icon: 'fas fa-home',
                },
                acl: {
                    view: 'PSP_00001',
                },
            },
            settings: {
                menu: {
                    route: `${code}.settings`,
                    text: 'settings.titles',
                    icon: 'fas fa-cogs',
                },
                acl: {
                    view                    : 'PSP_00008',
                    edit                    : 'PSP_00009',
                },
                url: {
                    getConfig               : `/${codeAPI}/gestao/definitions`,
                },
            },
            default_layers: {
                menu: {
                    route: `${code}.default_layers`,
                    text: 'default_layers.titles',
                    icon: 'fas fa-layer-group',
                },
                acl: {
                    view                    : 'PSP_00100',
                    detail                  : 'PSP_00101',
                    add                     : 'PSP_00102',
                    edit                    : 'PSP_00103',
                    delete                  : 'PSP_00104',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/defaultlayers`,
                    getShow                 : `${codeAPI}/gestao/defaultlayers/:id`,
                    getCreate               : `${codeAPI}/gestao/defaultlayers`,
                    getUpdate               : `${codeAPI}/gestao/defaultlayers/:id`,
                    getDelete               : `${codeAPI}/gestao/defaultlayers/:id`,
                    getLists                : `${codeAPI}/gestao/defaultlayers/lists`,
                    getResources            : `/backoffice/gestao/ogc/remoteservices/resources`,
                },
            },
            layers: {
                menu: {
                    route: `${code}.layers`,
                    text: 'layers.titles',
                    icon: 'fas fa-layer-group',
                },
                acl: {
                    view                    : 'PSP_00004',
                    detail                  : 'PSP_00003',
                    add                     : 'PSP_00093',
                    edit                    : 'PSP_00094',
                    delete                  : 'PSP_00005',
                    private                 : 'PSP_00093',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/layers`,
                    getShow                 : `${codeAPI}/gestao/layers/:id`,
                    getCreate               : `${codeAPI}/gestao/layers`,
                    getUpdate               : `${codeAPI}/gestao/layers/:id`,
                    getDelete               : `${codeAPI}/gestao/layers/:id`,
                    getLists                : `${codeAPI}/gestao/layers/lists`,
                    getResources            : `/backoffice/gestao/ogc/remoteservices/resources`,
                },
            },
            regulations: {
                menu: {
                    route: `${code}.regulations`,
                    text: `regulations.titles`,
                    icon: 'fas fa-book',
                },
                acl: {
                    view                    : 'PSP_00013',
                    detail                  : 'PSP_00012',
                    add                     : 'PSP_00010',
                    edit                    : 'PSP_00011',
                    delete                  : 'PSP_00014',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/regulations`,
                    getShow                 : `${codeAPI}/gestao/regulations/:id`,
                    getCreate               : `${codeAPI}/gestao/regulations`,
                    getUpdate               : `${codeAPI}/gestao/regulations/:id`,
                    getDelete               : `${codeAPI}/gestao/regulations/:id`,
                    getLists                : `${codeAPI}/gestao/regulations/lists`,
                },
            },
            print_visible_emissions: {
                menu: {
                    route: `${code}.print_visible_emissions.config`,
                    text: 'print_visible_emissions.titles',
                    icon: 'fas fa-print',
                },
                acl: {
                    view                    : 'PSP_00006',
                    config                  : 'PSP_00006',
                    configEdit              : 'PSP_00007',
                },
                url: {
                    getList                 : `/${codeAPI}/gestao/printvisible`,

                    getConfig               : `/${codeAPI}/gestao/printvisible/settings`,
                    getApps                 : `/${codeAPI}/gestao/printvisible/print/apps`,
                },
            },
            accident_types: {
                menu: {
                    route: `${code}.accident_types`,
                    text: 'Tipos de Acidente',
                    icon: 'fas fa-list',
                },
                acl: {
                    view                    : 'PSP_00043',
                    detail                  : 'PSP_00042',
                    add                     : 'PSP_00040',
                    edit                    : 'PSP_00041',
                    delete                  : 'PSP_00044',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/accidenttypes`,
                    getShow                 : `${codeAPI}/gestao/accidenttypes/:id`,
                    getCreate               : `${codeAPI}/gestao/accidenttypes`,
                    getUpdate               : `${codeAPI}/gestao/accidenttypes/:id`,
                    getDelete               : `${codeAPI}/gestao/accidenttypes/:id`,
                    getGroups               : `${codeAPI}/gestao/accidenttypes/groups`,
                },
            },
            atmosphere_types: {
                menu: {
                    route: `${code}.atmosphere_types`,
                    text: 'Condições Atmosféricas',
                    icon: 'fas fa-list',
                },
                acl: {
                    view                    : 'PSP_00018',
                    detail                  : 'PSP_00017',
                    add                     : 'PSP_00015',
                    edit                    : 'PSP_00016',
                    delete                  : 'PSP_00019',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/atmospheretypes`,
                    getShow                 : `${codeAPI}/gestao/atmospheretypes/:id`,
                    getCreate               : `${codeAPI}/gestao/atmospheretypes`,
                    getUpdate               : `${codeAPI}/gestao/atmospheretypes/:id`,
                    getDelete               : `${codeAPI}/gestao/atmospheretypes/:id`,
                },
            },
            driver_age_types: {
                menu: {
                    route: `${code}.driver_age_types`,
                    text: 'Idades do Condutor',
                    icon: 'fas fa-list',
                },
                acl: {
                    view                    : 'PSP_00023',
                    detail                  : 'PSP_00022',
                    add                     : 'PSP_00020',
                    edit                    : 'PSP_00021',
                    delete                  : 'PSP_00024',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/driveragetypes`,
                    getShow                 : `${codeAPI}/gestao/driveragetypes/:id`,
                    getCreate               : `${codeAPI}/gestao/driveragetypes`,
                    getUpdate               : `${codeAPI}/gestao/driveragetypes/:id`,
                    getDelete               : `${codeAPI}/gestao/driveragetypes/:id`,
                },
            },
            luminosity_types: {
                menu: {
                    route: `${code}.luminosity_types`,
                    text: 'Tipos de Luminosidade',
                    icon: 'fas fa-list',
                },
                acl: {
                    view                    : 'PSP_00028',
                    detail                  : 'PSP_00027',
                    add                     : 'PSP_00025',
                    edit                    : 'PSP_00026',
                    delete                  : 'PSP_00029',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/luminositytypes`,
                    getShow                 : `${codeAPI}/gestao/luminositytypes/:id`,
                    getCreate               : `${codeAPI}/gestao/luminositytypes`,
                    getUpdate               : `${codeAPI}/gestao/luminositytypes/:id`,
                    getDelete               : `${codeAPI}/gestao/luminositytypes/:id`,
                },
            },
            road_conservation_state_types: {
                menu: {
                    route: `${code}.road_conservation_state_types`,
                    text: 'Estados de Conservação',
                    icon: 'fas fa-list',
                },
                acl: {
                    view                    : 'PSP_00033',
                    detail                  : 'PSP_00032',
                    add                     : 'PSP_00030',
                    edit                    : 'PSP_00031',
                    delete                  : 'PSP_00034',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/roadconservationstatetypes`,
                    getShow                 : `${codeAPI}/gestao/roadconservationstatetypes/:id`,
                    getCreate               : `${codeAPI}/gestao/roadconservationstatetypes`,
                    getUpdate               : `${codeAPI}/gestao/roadconservationstatetypes/:id`,
                    getDelete               : `${codeAPI}/gestao/roadconservationstatetypes/:id`,
                },
            },
            vehicle_types: {
                menu: {
                    route: `${code}.vehicle_types`,
                    text: 'Tipos de Veículo',
                    icon: 'fas fa-list',
                },
                acl: {
                    view                    : 'PSP_00038',
                    detail                  : 'PSP_00037',
                    add                     : 'PSP_00035',
                    edit                    : 'PSP_00036',
                    delete                  : 'PSP_00039',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/vehicletypes`,
                    getShow                 : `${codeAPI}/gestao/vehicletypes/:id`,
                    getCreate               : `${codeAPI}/gestao/vehicletypes`,
                    getUpdate               : `${codeAPI}/gestao/vehicletypes/:id`,
                    getDelete               : `${codeAPI}/gestao/vehicletypes/:id`,
                },
            },
            accident_years: {
                menu: {
                    route: `${code}.accident_years`,
                    text: 'Anos',
                    icon: 'fas fa-list',
                },
                acl: {
                    view                    : 'PSP_00047',
                    detail                  : 'PSP_00046',
                    add                     : 'xxxx', // DON'T USE
                    edit                    : 'PSP_00045',
                    delete                  : 'xxxx', // DON'T USE
                },
                url: {
                    getList                 : `${codeAPI}/gestao/accidentyears`,
                    getShow                 : `${codeAPI}/gestao/accidentyears/:id`,
                    getCreate               : `${codeAPI}/gestao/accidentyears`,
                    getUpdate               : `${codeAPI}/gestao/accidentyears/:id`,
                    getDelete               : `${codeAPI}/gestao/accidentyears/:id`,
                },
            },
        },
        tools: {

        }
    },
};

export default state;